import Amplify, { Hub } from "@aws-amplify/core"
import Auth from "@aws-amplify/auth"
import API from "@aws-amplify/api"
import Storage from "@aws-amplify/storage"
import awsmobile from "aws-exports"

const config = {
	Auth: {
		identityPoolId: "us-east-1:b7892ae7-f7fe-44fd-85f7-fce68109bb15",
		region: "us-east-1",
		identityPoolRegion: "us-east-1",
		userPoolId: "us-east-1_wFd3rGV9h",
		userPoolWebClientId: "1ccdl7oop8esth4bo70bahec52",
		mandatorySignIn: true,
	},
	Storage: {
		level: "public",
		customPrefix: {
			public: "",
			protected: "",
			private: "",
		},
		AWSS3: {
			bucket: "gcs-monitor-resources",
			region: "us-east-1",
		},
	},
	...awsmobile,
	graphql_headers: async () => {
		return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() }
	},
}
// Amplify.Logger.LOG_LEVEL = 'DEBUG';

Amplify.configure(config)
API.configure(config)
Auth.configure()
Storage.configure(config.Storage)

const s3Config = config.Storage.AWSS3

// Auth.currentCredentials().then((info) => {
//   const cognitoIdentityId = info.data.IdentityId;
//   console.log(cognitoIdentityId)
// });

export { Auth as authRef, Hub as hubRef, s3Config }
